// This is Old Appointment Page Component


import React from "react";

const Appointments = () => {
  return (
    <>
      <div className="appointment-main">
        <div className="container-md bg-primary mt-3 p-3">
          <div className="container mt-2 text-center">
            <i className="bi bi-calendar fs-1 text-white "></i>
          </div>
          <div className="h1 text-center text-white">
            Book Appointment with us.
          </div>
          <div className="container text-center text-white">
            <p>Schedule your service appointment in just a few minutes</p>
          </div>
        </div>
        <div className="container-md">
          <form>
            <div className="container col-md-11 bg-white p-3 mt-2 shadow rounded ">
              <div className="h2">
                <p>Appointment Details</p>
              </div>
              <div className="row ">
                <div className="col-md-6 mt-2">
                  <label className="form-label" for="car-make">
                    Date *
                  </label>
                  <input type="date" className="form-control"></input>
                </div>
                <div className="col-md-6 mt-2">
                  <label className="form-label" for="car-make">
                    Time *{" "}
                  </label>
                  <input
                    type="time"
                    className="form-control"
                    min="09:00"
                    max="17:00"
                    step="1800" // optional
                    required
                  />
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md mt-2">
                  <label className="form-label" for="car-make">
                    Required Service *{" "}
                  </label>
                  <select
                    class="form-select"
                    placeholder="Default select example"
                  >
                    <option disabled selected hidden>
                      Select a service
                    </option>
                    <option>Oil Change</option>
                    <option>Brake Repair</option>
                    <option>Engine Diagnostics</option>
                    <option>Tire Rotation & Alignment</option>
                    <option>Battery Replacement</option>
                    <option>Air Conditioning Service</option>
                    <option>Transmission Service</option>
                    <option>Electrical Repair</option>
                    <option>Other</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="container col-md-11 bg-white p-3 mt-2 shadow rounded ">
              <div className="h2">
                <p>Car Details</p>
              </div>
              <div className="row ">
                <div className="col-md-6 mt-2">
                  <label className="form-label" for="car-make">
                    Car Make *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="eg. Audi, Ford, Honda"
                  ></input>
                </div>
                <div className="col-md-6 mt-2">
                  <label className="form-label" for="car-make">
                    Car Model *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="eg. A4, F-150, Civic"
                  ></input>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6 mt-2">
                  <label className="form-label" for="car-make">
                    Year *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="eg. 2020"
                  ></input>
                </div>
                <div className="col-md-6 mt-2">
                  <label className="form-label" for="car-make">
                    License Plate{" "}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Optional"
                  ></input>
                </div>
              </div>
            </div>
            <div className="container col-md-11 bg-white p-3 mt-4 shadow rounded">
              <div className="h2">
                <p>Conatact Details</p>
              </div>
              <div className="col-md mb-2">
                <label className="form-label" for="name">
                  {" "}
                  Full Name *{" "}
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Your full name"
                ></input>
              </div>
              <div className="col-md mb-2">
                <label className="form-label" for="name">
                  {" "}
                  Phone Number *{" "}
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Your full name"
                ></input>
              </div>
              <div className="col-md mb-2">
                <label className="form-label" for="name">
                  {" "}
                  Email *{" "}
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Your full name"
                ></input>
              </div>
            </div>
            <div className="container col-md-11 p-3 mt-4 ">
              <button className="btn btn-lg btn-primary w-100 ">
                Book Appointment
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Appointments;
